export class CreateOrganizationUserResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "user",
            "baseName": "user",
            "type": "OrganizationUser",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateOrganizationUserResponse.attributeTypeMap;
    }
    constructor() {
    }
}
